// utils\helpers\helperFunctions.js

import { client } from "@/utils/sanity";
import { serverTimestamp } from "firebase/firestore";
import { addToAuditTable } from "@/utils/firebasegen";
import {
  updateUserFieldWithUID,
  checkIfUserHasLoginAuditToday
} from "@/utils/firebaseFunctions";
import jwt from 'jsonwebtoken';

export function watchSentReports(user) {
  let obj = {
    user: user,
    latest_report_time: new Date().getTime(),
    count: 1,
  };

  if (!localStorage.getItem("sentReports")) {
    localStorage.setItem("sentReports", JSON.stringify([obj]));
  } else {
    let sentReports = JSON.parse(localStorage.getItem("sentReports"));

    if (!sentReports.find((report) => report.user?.user_id === user?.user_id)) {
      sentReports.push(obj);
    }

    sentReports.forEach((report) => {
      if (new Date().getTime() - report.latest_report_time > 3600000 && report.user?.user_id === user?.user_id) {
        report.count = 0;
        report.latest_failed_time = 0;
      }
    });

    sentReports.find((report) => {
      if (report.user?.user_id === user?.user_id) {
        report.latest_report_time = new Date().getTime();
        report.count++;
      }
    });

    localStorage.setItem("sentReports", JSON.stringify(sentReports));
  }
}

export function checkSentReportsForDisabling(user) {
  if (!localStorage.getItem("sentReports")) return true;
  let sentReports = JSON.parse(localStorage.getItem("sentReports"));
  let found = sentReports.find((report) => report.user?.user_id === user?.user_id);
  if (found && found.count > 2 && new Date().getTime() - found.latest_report_time < 3600000) {
    return false;
  } else {
    return true;
  }
}

export function watchFailedBindTries(handle, user) {
  let obj = {
    id: handle.handle_name,
    user: user,
    latest_failed_time: new Date().getTime(),
    count: 0,
  };

  if (!localStorage.getItem("failedBinds")) {
    localStorage.setItem("failedBinds", JSON.stringify([obj]));
  } else {
    let failedBinds = JSON.parse(localStorage.getItem("failedBinds"));

    if (!failedBinds.find((bind) => bind.handle_name === handle.handle_name && bind.user?.user_id === user?.user_id)) {
      failedBinds.push(obj);
    }

    failedBinds.forEach((bind) => {
      if (new Date().getTime() - bind.latest_failed_time > 3600000 && bind.user?.user_id === user?.user_id) {
        bind.count = 0;
        bind.latest_failed_time = 0;
      }
    });

    failedBinds.find((bind) => {
      if (bind.handle_name === handle.handle_name && bind.user?.user_id === user?.user_id) {
        bind.latest_failed_time = new Date().getTime();
        bind.count++;
      }
    });

    localStorage.setItem("failedBinds", JSON.stringify(failedBinds));
  }
}

export function checkFailedBindsForDisabling(handle, givenUser) {
  if (!localStorage.getItem("failedBinds")) return true;
  let failedBinds = JSON.parse(localStorage.getItem("failedBinds"));
  let found = failedBinds.find((bind) => bind.handle_name === handle.handle_name && bind.user?.user_id === givenUser?.user_id);
  if (found && found.count > 2 && new Date().getTime() - found.latest_failed_time < 3600000) {
    return false;
  } else {
    return true;
  }
}

export const reloadPage = () => {
  window.location.reload();
};

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export const setNewTime = (setState) => {
  const countdownDate = new Date(new Date().setUTCHours(24, 0, 0, 0)).getTime();
  if (countdownDate) {
    const currentTime = new Date().getTime();
    const distanceToDate = countdownDate - currentTime;

    let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distanceToDate % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

    const numbersToAddZeroTo = [1, 2, 3, 4, 5, 6, 7, 8, 9];

    days = `${days}`;
    if (numbersToAddZeroTo.includes(hours)) {
      hours = `0${hours}`;
    } else if (numbersToAddZeroTo.includes(minutes)) {
      minutes = `0${minutes}`;
    } else if (numbersToAddZeroTo.includes(seconds)) {
      seconds = `0${seconds}`;
    }

    setState({ days: days, hours: hours, minutes, seconds });
  }
};

export const fetchLeaderboardInMissions = async (direction = "initial", tabIndex = 0, setLeaderboardLoading, setLeaderboard, leaderboardLastGoldCounts, setLeaderboardLastGoldCounts, leaderboardLastRanks, setLeaderboardLastRanks) => {
  setLeaderboardLoading(true);
  setLeaderboard(null);

  if (direction === "initial") {
    setLeaderboardLastGoldCounts([]);
    setLeaderboardLastRanks([]);
  }

  const getCategory = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        return "all_time";
      case 1:
        return "daily";
      case 2:
        return "weekly";
      case 3:
        return "monthly";
      case 4:
        return "yearly";
      default:
        return "all_time";
    }
  };

  const category = getCategory(tabIndex);

  let url = `https://us-central1-prodmxs.cloudfunctions.net/getAllLeaderboardsPaginated?limit=10&category=${category}${category === "all_time" ? "&withBonuses=true" : ``}`;

  if (direction === "next") {
    const lastRank = leaderboardLastRanks[leaderboardLastRanks.length - 1];
    const lastGoldCount = leaderboardLastGoldCounts[leaderboardLastGoldCounts.length - 1];
    url += `&lastRank=${lastRank}&lastGoldCount=${lastGoldCount}`;
  } else if (direction === "prev") {
    const lastRank = leaderboardLastRanks[leaderboardLastRanks.length - 3] || "";
    const lastGoldCount = leaderboardLastGoldCounts[leaderboardLastGoldCounts.length - 3] || "";
    url += `&lastRank=${lastRank}&lastGoldCount=${lastGoldCount}`;
  }

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "aad235a0-7fcc-079f-e33f-53c65fbc4c81",
    },
  });

  const data = await response.json();
  setLeaderboard(data);

  const updateLeaderboard = (data, tabIndex) => {
    if (tabIndex === 0) {
      setLeaderboardLastGoldCounts((prevCounts) => [...prevCounts, data.data[data.data.length - 1].all_time_mxs_gold_with_bonuses]);
      setLeaderboardLastRanks((prevIds) => [...prevIds, data.data[data.data.length - 1].rank_with_bonuses]);
    } else if (tabIndex === 1) {
      setLeaderboardLastGoldCounts((prevCounts) => [...prevCounts, data.data[data.data.length - 1].daily_mxs_gold]);
      setLeaderboardLastRanks((prevIds) => [...prevIds, data.data[data.data.length - 1].rank_daily]);
    } else if (tabIndex === 2) {
      setLeaderboardLastGoldCounts((prevCounts) => [...prevCounts, data.data[data.data.length - 1].weekly_mxs_gold]);
      setLeaderboardLastRanks((prevIds) => [...prevIds, data.data[data.data.length - 1].rank_weekly]);
    } else if (tabIndex === 3) {
      setLeaderboardLastGoldCounts((prevCounts) => [...prevCounts, data.data[data.data.length - 1].monthly_mxs_gold]);
      setLeaderboardLastRanks((prevIds) => [...prevIds, data.data[data.data.length - 1].rank_monthly]);
    } else if (tabIndex === 4) {
      setLeaderboardLastGoldCounts((prevCounts) => [...prevCounts, data.data[data.data.length - 1].yearly_mxs_gold]);
      setLeaderboardLastRanks((prevIds) => [...prevIds, data.data[data.data.length - 1].rank_yearly]);
    }
  };

  updateLeaderboard(data, tabIndex);

  if (direction === "prev") {
    let newLastGoldCounts = leaderboardLastGoldCounts.slice(0, leaderboardLastGoldCounts.length - 1);
    let newLastRanks = leaderboardLastRanks.slice(0, leaderboardLastRanks.length - 1);

    setLeaderboardLastGoldCounts(newLastGoldCounts);
    setLeaderboardLastRanks(newLastRanks);
  }

  setLeaderboardLoading(false);
};

export const fetchVideoBanner = async (title, setVideoBannerURL, setVideoBannerMobileURL) => {
  try {
    const query = `*[_type == "videoBanners"]`;
    const fetchedVideoBanners = await client.fetch(query);
    fetchedVideoBanners.forEach((banner) => {
      if (banner.title === title) {
        setVideoBannerURL(banner.banner.url);
        setVideoBannerMobileURL(banner.mobileBanner.url);
      }
    });
  } catch (error) {
    console.error("Error fetching video banners:", error);
  }
};

export const getIPAddress = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Error fetching IP:", error);
    return null; // Return null or handle the error as needed
  }
};

export const getUser = async (params) => {
  let url = `https://us-central1-prodmxs.cloudfunctions.net/getUser?`;

  for (const key in params) {
    if (params[key]) {
      url += `${key}=${params[key]}&`;
    }
  }

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "aad235a0-7fcc-079f-e33f-53c65fbc4c81",
    },
  });

  const data = await response.json();
  return data;
};

export const getUserPoints = async (params) => {
  let url = `https://us-central1-prodmxs.cloudfunctions.net/getUserPoints?`;

  for (const key in params) {
    if (params[key]) {
      url += `${key}=${params[key]}&`;
    }
  }

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "aad235a0-7fcc-079f-e33f-53c65fbc4c81",
    },
  });

  const data = await response.json();
  return data;
};

export const setUser = async (params) => {
  let url = `https://us-central1-prodmxs.cloudfunctions.net/setUser?`;

  for (const key in params) {
    if (params[key]) {
      url += `${key}=${params[key]}&`;
    }
  }

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "aad235a0-7fcc-079f-e33f-53c65fbc4c81",
    },
  });

  const data = await response.json();
  return data;
};

export const addLoginAudit = async (user, ipAddress) => {
  const ifUserLoggedInToday = await checkIfUserHasLoginAuditToday(user.user_id || user.uid);

  if (ifUserLoggedInToday) return;

  try {
    await addToAuditTable({
      uid: `${user.user_id || user.uid}`,
      event: "LOGIN",
      sub_event: "WEBSITE",
      type: "DAILY",
      game_name: "",
      ip_address: `${ipAddress === null ? "" : ipAddress}`,
      success: true,
      email: `${user.email === null ? "" : user.email}`,
      comment: "Login successful",
      referrer_uid: user.referred_by_uid || user.referrer_uid
    });

    try {
      await updateUserFieldWithUID(user.user_id || user.uid, "last_login", serverTimestamp());
    } catch (error) {
      console.error("Error updating last_login field:", error);
    }
  } catch (error) {
    console.error("Error adding login audit:", error);
  }
};

export const fetchUserReferralsLeaderboard = async (
  page = 1,
  tabIndex = 0,
  setLeaderboardLoading,
  setLeaderboard,
  setPagination
) => {
  try {
    setLeaderboardLoading(true);

    const type = tabIndex === 0 ? "signup" : "active";
    let url = `https://us-central1-prodmxs.cloudfunctions.net/getUserReferralsLeaderboardPaginated?limit=10&type=${type}&page=${page}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "aad235a0-7fcc-079f-e33f-53c65fbc4c81",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    // Validate the response data structure
    if (!data || !data.data) {
      throw new Error('Invalid response data structure');
    }

    // Set default pagination values if not present
    const paginationData = {
      currentPage: page,
      hasNext: data?.pagination?.hasNext ?? false,
      hasPrev: page > 1, // If we're past page 1, we can go back
      pageSize: data?.pagination?.pageSize ?? 10
    };

    // Update states with the response data
    setLeaderboard(data.data);
    setPagination(paginationData);

    setLeaderboardLoading(false);
    return {
      data: data.data,
      pagination: paginationData
    };
  } catch (error) {
    console.error("Error fetching leaderboard:", error);
    // Set default states in case of error
    setLeaderboard([]);
    setPagination({
      currentPage: page,
      hasNext: false,
      hasPrev: page > 1,
      pageSize: 10
    });
    setLeaderboardLoading(false);
    throw error;
  }
};

export const showNumberWithCommas = (number) => {
  return parseFloat(number.toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatNumber = (num) => {
  if (num >= 1e9) {
    return (num / 1e9).toFixed(1) + 'B';
  } else if (num >= 1e6) {
    return (num / 1e6).toFixed(1) + 'M';
  } else if (num >= 1e3) {
    return (num / 1e3).toFixed(1) + 'K';
  } else {
    return num % 1 === 0 ? num.toString() : num.toFixed(2).toString();
  }
};

export const generateJWTToken = (user = null) => {
  if (!process.env.NEXT_PUBLIC_SUPABASE_JWT_SECRET) {
    console.log("NEXT_PUBLIC_SUPABASE_JWT_SECRET not found in environment variables");
    return null;
  }

  if (!process.env.NEXT_PUBLIC_SUPABASE_URL) {
    console.log("NEXT_PUBLIC_SUPABASE_URL not found in environment variables");
    return null;
  }

  const payload = {
    sub: user?.uid || 1234567890,
    iss: process.env.NEXT_PUBLIC_SUPABASE_URL,
    aud: process.env.NEXT_PUBLIC_SUPABASE_URL + '/auth/v1',
  };

  const options = {
    expiresIn: '5m',
  };

  const token = jwt.sign(payload, String(process.env.NEXT_PUBLIC_SUPABASE_JWT_SECRET), options);
  return token;
};

export const getUserFromSupabase = async (address) => {
  try {
    const token = generateJWTToken();
    const response = await fetch(
      `https://cqfjxolodeqrlvaifybm.supabase.co/functions/v1/get-user?wallet=${address}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching user from Supabase:", error);
    return null;
  }
};
